module.exports = __webpack_public_path__ + "static/media/knoob_equipment.7db7a0c2.png";